<script>
export { render as render };
export { staticRenderFns as staticRenderFns };
var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      attrs: {
        "hide-footer": "",
        "hide-header": "",
        id: "store-country",
        centered: "",
        size: "sm",
        "no-close-on-backdrop": true,
      },
      on: {
        hide: function ($event) {
          return _vm.onModalHidden(false)
        },
      },
      model: {
        value: _vm.modalVisible,
        callback: function ($$v) {
          _vm.modalVisible = $$v
        },
        expression: "modalVisible",
      },
    },
    [
      _c(
        "div",
        { staticClass: "modal-ui" },
        [
          _c("div", { staticClass: "rc-modal-title" }, [
            _vm._v(" " + _vm._s(_vm.$t("login.continueGoogle-title")) + " "),
          ]),
          _c("validation-observer", {
            ref: "registerForm",
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (ref) {
                  return [
                    _c(
                      "b-form",
                      { staticClass: "auth-register-form mt-2" },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t("register.Country"),
                              "label-for": "country ",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "label",
                                  fn: function () {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("Kyc.register.Country")
                                          ) + " "
                                        ),
                                        _c(
                                          "span",
                                          { staticClass: "red-star" },
                                          [_vm._v("*")]
                                        ),
                                      ]),
                                    ]
                                  },
                                  proxy: true,
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("validation-provider", {
                              attrs: {
                                name: _vm.$t("register.country"),
                                id: "country",
                                rules: "required",
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function (ref) {
                                      var errors = ref.errors
                                      return [
                                        _c(
                                          "div",
                                          {
                                            attrs: {
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                            },
                                          },
                                          [
                                            _c("CountrySelect", {
                                              attrs: {
                                                name: _vm.$t(
                                                  "register.country"
                                                ),
                                                placeholder: _vm.$t(
                                                  "register.countryPlaceholder"
                                                ),
                                                autocomplete: "off",
                                                clearable: false,
                                                reduce: "id",
                                              },
                                              model: {
                                                value: _vm.country,
                                                callback: function ($$v) {
                                                  _vm.country = $$v
                                                },
                                                expression: "country",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("Errors", {
                                          attrs: { error: errors[0] },
                                        }),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(
                              "b-button",
                              {
                                staticClass: "mt-1 mb-1 min-120-btn",
                                attrs: { variant: "primary" },
                                on: { click: _vm.saveCountryCode },
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "mr-25 align-middle" },
                                  [_vm._v(_vm._s(_vm.$t("login.Continue")))]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true



//# sourceURL=webpack:///./src/layouts/components/StoreCountryCode.vue?./node_modules/cache-loader/dist/cjs.js?%7B%22cacheDirectory%22:%22node_modules/.cache/vue-loader%22,%22cacheIdentifier%22:%229dcd27b4-vue-loader-template%22%7D!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options

import layouts_components_Errors_vue from '@/layouts/components/Errors.vue';
import * as veevalidate from 'vee-validate';
import core_layouts_components_Logo_vue from '@core/layouts/components/Logo.vue';
import * as bootstrapvue from 'bootstrap-vue';
import validations from '@validations';
import core_components_toastification_ToastificationContent_vue from '@core/components/toastification/ToastificationContent.vue';
import libs_api_api from '@/libs/api/api';
import layouts_components_CountrySelect_vue from '@/layouts/components/CountrySelect.vue';
import * as vuex from 'vuex';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










export default ({
  render,
  staticRenderFns,
  name: "",
  props: {
    showPop: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    onModalHidden: {
      type: Function,
      isRequired: true,
      default: () => {}
    }
  },
  components: {
    VuexyLogo: core_layouts_components_Logo_vue,
    BForm: bootstrapvue["BForm"],
    BButton: bootstrapvue["BButton"],
    BFormGroup: bootstrapvue["BFormGroup"],
    BFormInput: bootstrapvue["BFormInput"],
    ValidationProvider: veevalidate["ValidationProvider"],
    ValidationObserver: veevalidate["ValidationObserver"],
    CountrySelect: layouts_components_CountrySelect_vue,
    BModal: bootstrapvue["BModal"],
    Errors: layouts_components_Errors_vue
  },
  data() {
    return {
      modalVisible: this.showPop,
      lang: this.$route.params.lang,
      required: validations["required"],
      country: "IN"
    };
  },
  mounted() {},
  watch: {
    showPop(newValue) {
      this.modalVisible = newValue;
    }
  },
  computed: {
    ...vuex.mapState("user", ["user"])
  },
  methods: {
    ...vuex.mapMutations("user", ["setUser"]),
    async saveCountryCode() {
      try {
        const res = await new libs_api_api().api({
          method: "POST",
          url: "auth/user/saveCountryCode"
        }, {
          countryCode: this.country
        }, {});
        if (res && res.result && res.result.requestStatus === "SUCCESS") {
          this.setUser({
            ...this.user,
            countryCode: this.country
          });
          this.modalVisible = false;
        } else if (res && res.error && res.error.message) {
          this.$toast({
            component: core_components_toastification_ToastificationContent_vue,
            props: {
              title: res.error.message,
              icon: "EditIcon",
              variant: "danger"
            }
          });
        }
      } catch (error) {
        this.$toast({
          component: core_components_toastification_ToastificationContent_vue,
          props: {
            title: error,
            icon: "EditIcon",
            variant: "danger"
          }
        });
      }
    }
  }
});

//# sourceURL=webpack:///./src/layouts/components/StoreCountryCode.vue?./node_modules/cache-loader/dist/cjs.js??ref--13-0!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--1-0!./node_modules/vue-loader/lib??vue-loader-options
</script>

